<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Enquiry Details" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3">
                                <div class="col-12 float-end">
                                    <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>

                                </div>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Job Details
                                        </h4>

                                        <div class="table table-responsive">
                                            <table class="details-table table-nowrap mb-0">
                                                <tbody>

                                                    <tr width="50%">
                                                        <th scope="row">Customer Name</th>
                                                        <th>:</th>
                                                        <td>{{ job.customer_name }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Contact</th>
                                                        <th>:</th>
                                                        <td>+91 {{ job.mobile }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Location</th>
                                                        <th>:</th>
                                                        <td>{{ job.location }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Vehcile Number</th>
                                                        <th>:</th>
                                                        <td>{{ job.vehicle_no }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Product</th>
                                                        <th>:</th>
                                                        <td>{{ job.product_name }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Work Type</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span v-if="job.service_type == 1">New</span>
                                                            <span v-else-if="job.service_type == 2">Repair</span>
                                                            <span v-else>Replacement</span>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Date</th>
                                                        <th>:</th>
                                                        <td>{{ proxy.$filters.convertDate(job.date) }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Status</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span class="badge rounded-pill bg-info" v-if="job.status == 1">Enquiry</span>
                                                            <span class="badge rounded-pill bg-warning" v-if="job.status == 2">FollowUp</span>
                                                            <span class="badge rounded-pill bg-success" v-if="job.status == 3">Completed</span>
                                                            <span class="badge rounded-pill bg-danger" v-if="job.status == 4">Cancelled</span>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-3">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Enquiry Log</h4>

                                        <div class="table-responsive product-table">
                                            <table class="display" id="basic-1">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Status</th>              
                                                        <th>Staff</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(log, index) in job_logs" :key="index">
                                                        <td>
                                                            {{ proxy.$filters.convertDate(log.date) }}
                                                        </td>
                                                        <td>
                                                            <span class="badge rounded-pill bg-info" v-if="log.status == 1">Enquiry</span>
                                                            <span class="badge rounded-pill bg-warning" v-if="log.status == 2">FollowUp</span>
                                                            <span class="badge rounded-pill bg-success" v-if="log.status == 3">Completed</span>
                                                            <span class="badge rounded-pill bg-danger" v-if="log.status == 4">Cancelled</span>
                                                        </td>
                                                        <td>{{ log.added_by_user_name }}</td>
                                                    </tr>
                                                </tbody>
                                                
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group">
                            <label class="control-label">Payment Type<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="payment_type">
								<option value="">--Select--</option>
								<option value="1">Cash</option>
								<option value="2">Online</option>
                                <option value="3">Both</option>
							</select>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="payment_type == 2 || payment_type == 3">
                            <label class="control-label">Payment Id<span class="text-danger">*</span></label>
                        	<input class="form-control" type="text" placeholder="" />
                        </div>
                        
                        <div class="col-md-6 form-group mt-2" v-if="payment_type == 3">
                            <label class="control-label">Cash Amount<span class="text-danger">*</span></label>
                        	<input class="form-control" type="text" placeholder="" />
                        </div>
                        <div class="col-md-6 form-group mt-2" v-if="payment_type == 3">
                            <label class="control-label">Online Amount<span class="text-danger">*</span></label>
                        	<input class="form-control" type="text" placeholder="" />
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" @click="closeModal()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

    </div>	
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, inject } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Modal } from "bootstrap";
import DynamicModal from '@/components/dynamic_modal.vue';
import { get } from '@/utils/api';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();
const imageUrl = inject('imageUrl');

const job_id = route.query.id;
const job = ref({});
const modal_title = "Update Work Status";
const button_title = "Update";
const errors = ref({});
const payment_type = ref("");
const job_logs = ref([]);

let dynamicmodal = null;

const showModal = () => {
    if (dynamicmodal) dynamicmodal.show();
};

const hideModal = () => {
    if (dynamicmodal) dynamicmodal.hide();
};

const closeModal = () => {
    hideModal();
};

const updateStatus = () => {
    errors.value = {};
    showModal();
};

const fetchJob = () => {

    const params = {
        job_id: job_id
    }

    get(routes.EnquiryDetail, { params }, false)
        .then((response) => {
            if(response.status === 200){
                console.log(response.data.data);
				job.value = response.data.data.details;
                job_logs.value = response.data.data.details.job_enquiry;
                console.log(job_logs.value);
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch job', 'error');
			}
        })
        .catch((error)  => {
            if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.job_id?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
            }
        });
};

onMounted(() => {
    dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
    fetchJob();
});
</script>
